
export const parseHTML = htmlString => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return {
    head: (doc.querySelector("head")?.innerHTML || "").trim(),
    body: (doc.querySelector("body")?.innerHTML || "").trim()
  };
};

  
export const buildFullHTML = (head, body, { isPreview = false, baseUrl = "" } = {}) => {
  const baseTag = isPreview && baseUrl ? `<base href="${baseUrl}">` : "";
  return `<html><head>${baseTag}${head}</head><body>${body}</body></html>`;
};

export function injectOverlaysIntoBody(bodyHTML, byRel) {
  const parser = new DOMParser();
  const doc    = parser.parseFromString(bodyHTML, "text/html");

  Object.entries(byRel).forEach(([rel, asset]) => {
    doc.querySelectorAll(`iframe[src$="${rel}"]`).forEach(frame => {
      if (frame.dataset.visualId) return;          // already done

      const id = asset.visual_id;
      frame.dataset.visualId = id;

      /* ⬇️ NEW: tag the anchor right before the iframe, if present */
      const maybeAnchor = frame.previousElementSibling;
      if (maybeAnchor?.tagName === "A") {
        maybeAnchor.dataset.visualId = id;
      }

      // --- existing wrapper / overlay code ---
      const wrapper = doc.createElement("div");
      wrapper.style.position = "relative";
      wrapper.dataset.mePreviewWrapper = "1";

      const overlay = doc.createElement("div");
      overlay.className        = "me-visual-overlay";
      overlay.dataset.visualId = id;
      Object.assign(overlay.style, { position: "absolute", inset: 0 });

      frame.replaceWith(wrapper);
      wrapper.append(frame, overlay);
    });
  });

  return doc.body.innerHTML;
}



export function serializeCleanHTML(doc) {
  const clone = doc.cloneNode(true);                // ✔ doesn’t mutate live DOM

  // 1. Remove overlays
  clone.querySelectorAll(".me-visual-overlay").forEach(n => n.remove());

  // 2. Unwrap everything inside preview wrappers
  clone.querySelectorAll("[data-me-preview-wrapper]").forEach(w => {
    const parent = w.parentNode;
    while (w.firstChild) {
      parent.insertBefore(w.firstChild, w);         // preserve order
    }
    parent.removeChild(w);
  });

  // 3. Strip runtime-only attributes
  clone.querySelectorAll("[data-visual-id]").forEach(el => {
    el.removeAttribute("data-visual-id");
  });

  return clone.body.innerHTML;
}
